import Vue from "vue";
import store from "../store";
import { px, formmatImg } from "./common";
import { showBox } from "../api/slicer/printer";
import { i18n } from "@/lang";
import { errorDialog, successDiv } from "./dialog";
import { defaultModelImg } from './defaultImg'
import materialsAll from '@/api/materialsAll'
import { isMacOS } from '@/utils/platform'

export function lanReceiveTopic(topic, payload) {
  // console.log(topic);
  console.log(topic, payload);

  let infoArr = topic.split("/");
  let modelKey = infoArr[6]; //机器key ----- deviceId
  let data = JSON.parse(payload);
  const { type, action, code } = data;

  if (data.type == "print" && data.code != 200 && data.code != 0) {
    // 打印出现错误
    let curPrinter = JSON.parse(JSON.stringify(store.getters.GET_CUR_PRINTER));
    if (curPrinter && store.getters.GET_LAN_MQTT?.deviceId == modelKey) {
      if (data.state == "pausing") {
        // console.log("进了报错pausing");
        store.commit("SET_LAN_LAYOUT_LOADING", false);
        curPrinter.project.pause = 2;
        store.commit("SET_CUR_PRINTER", curPrinter);
      }
      if (data.state == "paused") {
        // console.log("进了报错paused");
        store.commit("SET_LAN_LAYOUT_LOADING", false);
        curPrinter.project.pause = 1;
        store.commit("SET_CUR_PRINTER", curPrinter);
      }
      if (data.state == "stoped" || data.state == "failed") {
        // 用户结束任务
        store.commit("SET_LAN_LAYOUT_LOADING", false);
        curPrinter.project = undefined;
        store.commit("SET_CUR_PRINTER", curPrinter);
      }
    }

    let lanList = JSON.parse(
      JSON.stringify(store.getters.GET_LAN_PRINTER_LIST)
    );
    let idx = lanList.findIndex((item) => modelKey == item.deviceId);
    if (idx != -1) {
      if (!lanList[idx].project) {
        Vue.set(lanList[idx], "project", {});
      }

      if (data.state == "pausing") {
        // console.log("进了报错pausing");
        store.commit("SET_LAN_LAYOUT_LOADING", false);
        lanList[idx].project.pause = 2;
        store.commit("SET_LAN_PRINTER_LIST", lanList);
      }
      if (data.state == "paused") {
        // console.log("进了报错paused");

        store.commit("SET_LAN_LAYOUT_LOADING", false);
        lanList[idx].project.pause = 1;
        store.commit("SET_LAN_PRINTER_LIST", lanList);
      }
      if (data.state == "stoped" || data.state == "failed") {
        // 用户结束任务
        store.commit("SET_LAN_LAYOUT_LOADING", false);
        lanList[idx].project = undefined;
        store.commit("SET_LAN_PRINTER_LIST", lanList);
      }
    }
    store.commit("SET_LAN_LAYOUT_LOADING", false);
    // return false;
  }
  // 业务非成功情况不执行以下代码
  // if (![200, 0].includes(code)) {
  //   return false;
  // }
  // 任务开始
  if ([200, 0].includes(code) && type == "print" && action == "start") {
    startFun(modelKey, data);
  }
  // 任务结束
  if ([200, 0].includes(code) && type == "print" && action == "stop") {
    stopFun(modelKey, data);
  }
  // 任务暂停
  if ([200, 0].includes(code) && type == "print" && action == "pause") {
    pauseFun(modelKey, data);
  }
  // 任务继续
  if ([200, 0].includes(code) && type == "print" && action == "resume") {
    resumeFun(modelKey, data);
  }
  if (type == "tempature") {
    tempature(modelKey, data);
  }
  if (type == "fan") {
    fan(modelKey, data);
  }

  if (type == "light" && action == "query" && (code == 200 || code == 0)) {
    light(modelKey, data);
  }

  if (type == "light" && action == "control" && (code == 200 || code == 0)) {
    lightControl(modelKey, data);
  }

  if ([200, 0].includes(code) && type == "print" && action == "update") {
    updateFun(modelKey, data);
  }
  if ([200, 0].includes(code) && type == "status" && action == "workReport") {
    workReport(modelKey, data);
  }

  if ([200, 0].includes(code) && type == "info" && action == "report") {
    reportInfo(modelKey, data);
  }

  //  消息写入Vuex与错误成功弹框分开，解耦
  printingBefore(modelKey, topic, data);
  topicGetDialog(modelKey, topic, data);
  //  状态报错的额外处理
  if (data.code >= 10000 && data.code <= 19999) {
    errorAfter(modelKey, data.code)
  }
}

// 操作vuex数据  开始打印
function startFun (modelKey, payload) {
  let curPrinter =
    JSON.parse(JSON.stringify(store.getters.GET_CUR_PRINTER)) || {};
  let map = {
    printing: 1,
    finished: 2,
    failed: 3,
    downloading: 4,
    checking: 5,
    preheating: 6,
    slicing: 7,
    auto_leveling: 9,
    vibrating: 10,
    flow_calibrating: 11,
    drying:12
  };
  if (store.getters.GET_LAN_MQTT?.deviceId == modelKey) {
    if (!curPrinter.project) {
      Vue.set(curPrinter, "project", {});
    }

    if (
      payload.state == "preheating" ||
      payload.state == "printing" ||
      payload.state == "finished"
    ) {
      curPrinter.project.filename = payload.data.filename;
      // curPrinter.project.img = payload.data.img || "";
      // curPrinter.project.estimate =
      //   (parseInt(payload.data.print_time) +
      //     parseInt(payload.data.remain_time)) *
      //   60;
      curPrinter.project.print_time = payload.data.print_time;
      curPrinter.project.remain_time = payload.data.remain_time;
      // 毫米换算克
      let num = parseFloat(
        (
          (((Math.PI * (1.75 / 2) * 1.75) / 2) *
            payload.data.supplies_usage *
            1.23) /
          1000
        ).toFixed(2)
      );
      curPrinter.project.estimate_supplies_usage_g = num;
      curPrinter.project.supplies_usage = payload.data.supplies_usage;
      curPrinter.project.pause = 0;
      curPrinter.project.print_status = map[payload.state] || 6;
      curPrinter.project.progress = payload.data.progress;
      curPrinter.project.curr_layer = payload.data.curr_layer;
      curPrinter.project.total_layers = payload.data.total_layers;
      curPrinter.project.remain_time = payload.data.remain_time;
      curPrinter.project.task_id = payload.data.taskid;
      store.commit("SET_CUR_PRINTER", curPrinter);
    } else if (
      payload.state == "checking" ||
      payload.state == "failed" ||
      payload.state == "waiting" ||
      payload.state == "auto_leveling" ||
      payload.state == "vibrating" ||
      payload.state == "flow_calibrating" ||
      payload.state == "drying"
    ) {
      curPrinter.project.task_id = payload.data.taskid;
      curPrinter.project.print_status = map[payload.state];
      store.commit("SET_CUR_PRINTER", curPrinter);
    } else if (payload.state == "downloading") {
      curPrinter.project.task_id = payload.data.taskid;
      curPrinter.project.print_status = map[payload.state];
      curPrinter.project.progress = payload.data.progress;
      store.commit("SET_CUR_PRINTER", curPrinter);
    } else if (payload.state == "stopping") {
      store.commit("SET_LAN_LAYOUT_LOADING", false);
      curPrinter.project.pause = 4;
      store.commit("SET_CUR_PRINTER", curPrinter);
    } else if (payload.state == "updated") {
      let curPrinter = store.getters.GET_CUR_PRINTER;
      let project = curPrinter?.project;
      let curTask = store.getters.GET_CUR_TASK;
      if (store.getters.GET_LAN_MQTT?.deviceId == modelKey && project) {
        if (!curTask) {
          curTask = {
            temp: {
              curr_hotbed_temp: undefined,
              curr_nozzle_temp: undefined,
              target_hotbed_temp: undefined,
              target_nozzle_temp: undefined
            },
            fan_speed_pct: undefined,
            print_speed_mode: undefined,
            aux_fan_speed_pct: undefined,
            box_fan_level: undefined
          };
        }
        // console.log("进了update");
        curTask.temp.curr_hotbed_temp = payload.data.curr_hotbed_temp;
        curTask.temp.curr_nozzle_temp = payload.data.curr_nozzle_temp;
        curTask.temp.target_hotbed_temp =
          payload.data.settings?.target_hotbed_temp;
        curTask.temp.target_nozzle_temp =
          payload.data.settings?.target_nozzle_temp;
        curTask.fan_speed_pct = payload.data.settings?.fan_speed_pct;
        curTask.aux_fan_speed_pct = payload.data.settings?.aux_fan_speed_pct;
        curTask.box_fan_level = payload.data.settings?.box_fan_level;
        curTask.print_speed_mode = payload.data.settings?.print_speed_mode;
        store.commit("SET_CUR_TASK", curTask);
      }
    }
  }

  // 处理列表
  let lanList = JSON.parse(JSON.stringify(store.getters.GET_LAN_PRINTER_LIST));
  let idx = lanList.findIndex((item) => modelKey == item.deviceId);
  if (idx != -1) {
    if (!lanList[idx].project) {
      Vue.set(lanList[idx], "project", {});
    }

    if (
      payload.state == "preheating" ||
      payload.state == "printing" ||
      payload.state == "finished"
    ) {
      lanList[idx].project.filename = payload.data.filename;
      lanList[idx].project.print_time = payload.data.print_time;
      lanList[idx].project.remain_time = payload.data.remain_time;
      // 毫米换算克
      let num = parseFloat(
        (
          (((Math.PI * (1.75 / 2) * 1.75) / 2) *
            payload.data.supplies_usage *
            1.23) /
          1000
        ).toFixed(2)
      );
      lanList[idx].project.estimate_supplies_usage_g = num;
      lanList[idx].project.supplies_usage = payload.data.supplies_usage;
      lanList[idx].project.pause = 0;
      lanList[idx].project.print_status = map[payload.state] || 6;
      lanList[idx].project.progress = payload.data.progress;
      lanList[idx].project.curr_layer = payload.data.curr_layer;
      lanList[idx].project.total_layers = payload.data.total_layers;
      lanList[idx].project.remain_time = payload.data.remain_time;
      lanList[idx].project.task_id = payload.data.taskid;
      store.commit("SET_LAN_PRINTER_LIST", lanList);
    } else if (
      payload.state == "checking" ||
      payload.state == "failed" ||
      payload.state == "waiting" ||
      payload.state == "auto_leveling" ||
      payload.state == "vibrating" ||
      payload.state == "flow_calibrating" || 
      payload.state == "drying"
    ) {
      lanList[idx].project.task_id = payload.data.taskid;
      lanList[idx].project.print_status = map[payload.state];
      store.commit("SET_LAN_PRINTER_LIST", lanList);
    } else if (payload.state == "downloading") {
      lanList[idx].project.task_id = payload.data.taskid;
      lanList[idx].project.print_status = map[payload.state];
      lanList[idx].project.progress = payload.data.progress;
      store.commit("SET_LAN_PRINTER_LIST", lanList);
    } else if (payload.state == "stopping") {
      store.commit("SET_LAN_LAYOUT_LOADING", false);
      lanList[idx].project.pause = 4;
      store.commit("SET_LAN_PRINTER_LIST", lanList);
    }
  }
}
// 操作vuex数据
function stopFun(modelKey, payload) {
  let curPrinter =
    JSON.parse(JSON.stringify(store.getters.GET_CUR_PRINTER)) || {};
  if (store.getters.GET_LAN_MQTT?.deviceId == modelKey) {
    if (payload.state == "stopping") {
      store.commit("SET_LAN_LAYOUT_LOADING", false);
      curPrinter.project.pause = 4;
      store.commit("SET_CUR_PRINTER", curPrinter);
    }
    if (payload.state == "stoped") {
      store.commit("SET_LAN_LAYOUT_LOADING", false);
      curPrinter.project = undefined;
      store.commit("SET_CUR_PRINTER", curPrinter);
    }
  }

  let lanList = JSON.parse(JSON.stringify(store.getters.GET_LAN_PRINTER_LIST));
  let idx = lanList.findIndex((item) => modelKey == item.deviceId);
  if (idx != -1) {
    if (payload.state == "stopping") {
      store.dispatch("SET_LOADING_FALSE");
      lanList[idx].project.pause = 4;
      store.commit("SET_LAN_PRINTER_LIST", lanList);
    }
    if (payload.state == "stoped") {
      console.log("进了stoped");
      store.dispatch("SET_LOADING_FALSE");
      lanList[idx].project = undefined;
      store.commit("SET_LAN_PRINTER_LIST", lanList);
    }
  }
}

function pauseFun(modelKey, payload) {
  let curPrinter =
    JSON.parse(JSON.stringify(store.getters.GET_CUR_PRINTER)) || {};
  if (store.getters.GET_LAN_MQTT?.deviceId == modelKey) {
    if (payload.state == "pausing") {
      // console.log("进了pausing");
      store.commit("SET_LAN_LAYOUT_LOADING", false);
      curPrinter.project.pause = 2;
      store.commit("SET_CUR_PRINTER", curPrinter);
    }
    if (payload.state == "paused") {
      // console.log("进了paused");
      store.commit("SET_LAN_LAYOUT_LOADING", false);
      curPrinter.project.pause = 1;
      store.commit("SET_CUR_PRINTER", curPrinter);
    }
  }

  let lanList = JSON.parse(JSON.stringify(store.getters.GET_LAN_PRINTER_LIST));
  let idx = lanList.findIndex((item) => modelKey == item.deviceId);
  if (idx != -1) {
    if (payload.state == "pausing") {
      store.commit("SET_LAN_LAYOUT_LOADING", false);
      lanList[idx].project.pause = 2;
      store.commit("SET_LAN_PRINTER_LIST", lanList);
    }
    if (payload.state == "paused") {
      store.commit("SET_LAN_LAYOUT_LOADING", false);
      lanList[idx].project.pause = 1;
      store.commit("SET_LAN_PRINTER_LIST", lanList);
    }
  }
}

function resumeFun(modelKey, payload) {
  let curPrinter =
    JSON.parse(JSON.stringify(store.getters.GET_CUR_PRINTER)) || {};
  if (store.getters.GET_LAN_MQTT?.deviceId == modelKey) {
    if (payload.state == "resuming") {
      // console.log("进了resuming");
      store.commit("SET_LAN_LAYOUT_LOADING", false);
      curPrinter.project.pause = 3;
      store.commit("SET_CUR_PRINTER", curPrinter);
    }
    if (payload.state == "resumed") {
      // console.log("进了resumed");
      store.commit("SET_LAN_LAYOUT_LOADING", false);
      curPrinter.project.pause = 0;
      store.commit("SET_CUR_PRINTER", curPrinter);
    }
  }

  let lanList = JSON.parse(JSON.stringify(store.getters.GET_LAN_PRINTER_LIST));
  let idx = lanList.findIndex((item) => modelKey == item.deviceId);
  if (idx != -1) {
    if (payload.state == "resuming") {
      // console.log("进了resuming");
      store.commit("SET_LAN_LAYOUT_LOADING", false);
      lanList[idx].project.pause = 3;
      store.commit("SET_LAN_PRINTER_LIST", lanList);
    }
    if (payload.state == "resumed") {
      // console.log("进了resumed");
      store.commit("SET_LAN_LAYOUT_LOADING", false);
      lanList[idx].project.pause = 0;
      store.commit("SET_LAN_PRINTER_LIST", lanList);
    }
  }
}

// 操作vuex数据 更新温度
function tempature(modelKey, payload) {
  let curTask = store.getters.GET_CUR_TASK;
  let curPrinter = store.getters.GET_CUR_PRINTER;
  let project = curPrinter?.project;

  if (store.getters.GET_LAN_MQTT?.deviceId == modelKey && project) {
    if (!curTask) {
      curTask = {
        temp: {
          curr_hotbed_temp: undefined,
          curr_nozzle_temp: undefined,
          target_hotbed_temp: undefined,
          target_nozzle_temp: undefined
        },
        fan_speed_pct: undefined,
        print_speed_mode: undefined,
        aux_fan_speed_pct: undefined,
        box_fan_level: undefined
      };
    }
    // console.log("进了tempature", payload);
    curTask.temp.curr_hotbed_temp = payload.data.curr_hotbed_temp;
    curTask.temp.curr_nozzle_temp = payload.data.curr_nozzle_temp;
    curTask.temp.target_hotbed_temp = payload.data.target_hotbed_temp;
    curTask.temp.target_nozzle_temp = payload.data.target_nozzle_temp;
    store.commit("SET_CUR_TASK", curTask);
  }
}

// 操作vuex数据 更新风扇
function fan(modelKey, payload) {
  let curTask = store.getters.GET_CUR_TASK;
  let curPrinter = store.getters.GET_CUR_PRINTER;
  let project = curPrinter?.project;
  if (store.getters.GET_LAN_MQTT?.deviceId == modelKey && project) {
    if (!curTask) {
      curTask = {
        temp: {
          curr_hotbed_temp: undefined,
          curr_nozzle_temp: undefined,
          target_hotbed_temp: undefined,
          target_nozzle_temp: undefined
        },
        fan_speed_pct: undefined,
        print_speed_mode: undefined,
        aux_fan_speed_pct: undefined,
        box_fan_level: undefined
      };
    }
    // console.log("进了fan");
    curTask.fan_speed_pct = payload.data.fan_speed_pct;
    curTask.aux_fan_speed_pct = payload.data.aux_fan_speed_pct;
    curTask.box_fan_level = payload.data.box_fan_level;
    store.commit("SET_CUR_TASK", curTask);
  }
}

// 操作vuex数据 更新风扇
function light(modelKey, payload) {
  let curPrinter = JSON.parse(JSON.stringify(store.getters.GET_CUR_PRINTER));

  if (curPrinter && store.getters.GET_LAN_MQTT?.deviceId == modelKey) {
    if (!curPrinter.light) {
      Vue.set(curPrinter, "light", {
        ledHeader: false,
        ledCamera: false,
        ledBox: false
      });
    }
    if (
      payload.data &&
      payload.data.lights &&
      Array.isArray(payload.data.lights)
    ) {
      payload.data.lights.forEach((item) => {
        if (item.type == 1) {
          curPrinter.light.ledHeader = item.status == 1 ? true : false;
        } else if (item.type == 2) {
          curPrinter.light.ledBox = item.status == 1 ? true : false;
        } else if (item.type == 3) {
          curPrinter.light.ledCamera = item.status == 1 ? true : false;
        }
      });
    }
    store.commit("SET_CUR_PRINTER", curPrinter);
  }
}

function lightControl(modelKey, payload) {
  let curPrinter = JSON.parse(JSON.stringify(store.getters.GET_CUR_PRINTER));

  if (curPrinter && store.getters.GET_LAN_MQTT?.deviceId == modelKey) {
    if (!curPrinter.light) {
      Vue.set(curPrinter, "light", {
        ledHeader: false,
        ledCamera: false,
        ledBox: false
      });
    }
    if (payload.data) {
      if (payload.data.type == 1) {
        curPrinter.light.ledHeader = payload.data.status == 1 ? true : false;
      } else if (payload.data.type == 2) {
        curPrinter.light.ledBox = payload.data.status == 1 ? true : false;
      } else if (payload.data.type == 3) {
        curPrinter.light.ledCamera = payload.data.status == 1 ? true : false;
      }
    }
    store.commit("SET_CUR_PRINTER", curPrinter);
  }
}

// 操作vuex数据 更新温度、风扇、打印模式
function updateFun(modelKey, payload) {
  let curPrinter = store.getters.GET_CUR_PRINTER;
  let project = curPrinter?.project;
  let curTask = store.getters.GET_CUR_TASK;
  if (store.getters.GET_LAN_MQTT?.deviceId == modelKey && project) {
    if (!curTask) {
      curTask = {
        temp: {
          curr_hotbed_temp: undefined,
          curr_nozzle_temp: undefined,
          target_hotbed_temp: undefined,
          target_nozzle_temp: undefined
        },
        fan_speed_pct: undefined,
        print_speed_mode: undefined,
        aux_fan_speed_pct: undefined,
        box_fan_level: undefined
      };
    }
    // console.log("进了update");
    curTask.temp.curr_hotbed_temp = payload.data.curr_hotbed_temp;
    curTask.temp.curr_nozzle_temp = payload.data.curr_nozzle_temp;
    curTask.temp.target_hotbed_temp = payload.data.settings?.target_hotbed_temp;
    curTask.temp.target_nozzle_temp = payload.data.settings?.target_nozzle_temp;
    curTask.fan_speed_pct = payload.data.settings?.fan_speed_pct;
    curTask.aux_fan_speed_pct = payload.data.settings?.aux_fan_speed_pct;
    curTask.box_fan_level = payload.data.settings?.box_fan_level;
    curTask.print_speed_mode = payload.data.settings?.print_speed_mode;
    store.commit("SET_CUR_TASK", curTask);
  }
}

function workReport(modelKey, payload) {
  let curPrinter =
    JSON.parse(JSON.stringify(store.getters.GET_CUR_PRINTER)) || {};
  if (store.getters.GET_LAN_MQTT?.deviceId == modelKey) {
    curPrinter.status = payload.state;
    store.commit("SET_CUR_PRINTER", curPrinter);
  }

  // 处理列表
  let LanList = JSON.parse(JSON.stringify(store.getters.GET_LAN_PRINTER_LIST));
  let idx = LanList.findIndex((item) => modelKey == item.deviceId);
  if (idx != -1) {
    LanList[idx].status = payload.state;
    store.commit("SET_LAN_PRINTER_LIST", LanList);
  }
}

function reportInfo(modelKey, payload) {
  let curPrinter =
    JSON.parse(JSON.stringify(store.getters.GET_CUR_PRINTER)) || {};
  if (store.getters.GET_LAN_MQTT?.deviceId == modelKey) {
    curPrinter.deviceId = store.getters.GET_LAN_MQTT?.deviceId;
    curPrinter.img = formmatImg(payload.data?.model);
    curPrinter.name = payload.data?.printerName;
    curPrinter.model = payload.data?.model;
    curPrinter.ip = payload.data?.ip;
    curPrinter.version = {};
    curPrinter.version.firmware_version = payload.data?.version;
    curPrinter.status = payload.data?.state;
    curPrinter.project = payload.data?.project;
    if (curPrinter.project && Object.keys(curPrinter.project).length > 0) {
      let curTask = {
        temp: {
          curr_hotbed_temp: payload.data?.temp.curr_hotbed_temp,
          curr_nozzle_temp: payload.data?.temp.curr_nozzle_temp,
          target_hotbed_temp: payload.data?.temp.target_hotbed_temp,
          target_nozzle_temp: payload.data?.temp.target_nozzle_temp
        },
        fan_speed_pct: payload.data?.fan_speed_pct,
        print_speed_mode: payload.data?.project.print_speed_mode,
        aux_fan_speed_pct: payload.data?.aux_fan_speed_pct,
        box_fan_level: payload.data?.box_fan_level
      };
      store.commit("SET_CUR_TASK", curTask);
    }
    store.commit("SET_CUR_PRINTER", curPrinter);
  }

  // 处理列表
  let LanList = JSON.parse(JSON.stringify(store.getters.GET_LAN_PRINTER_LIST));
  let idx = LanList.findIndex((item) => modelKey == item.deviceId);
  if (idx != -1) {
    LanList[idx].img = formmatImg(payload.data?.model);
    LanList[idx].name = payload.data?.printerName;
    LanList[idx].model = payload.data?.model;
    LanList[idx].ip = payload.data?.ip;
    LanList[idx].version = {};
    LanList[idx].version.firmware_version = payload.data?.version;
    LanList[idx].status = payload.data?.state;
    LanList[idx].project = payload.data?.project;
    store.commit("SET_LAN_PRINTER_LIST", LanList);
  }
  store.commit("SET_LAN_LAYOUT_LOADING", false);
}
// 操作vuex数据
function printingBefore(modelKey, topic, data) {
  const params = {
    topic: topic,
    data: data
  };
  store.commit("SET_CUR_BEFORE_TASK", params);
}

function topicGetDialog(modelKey, topic, data) {
  let errorIdData = store.getters["GET_ERROR_ID_DATA"] || {};

  //  获取机器key，拿到机器name
  const printerList = store.getters.GET_LAN_PRINTER_LIST;
  const printerListIndex = printerList.findIndex(
    (item) => item?.deviceId == modelKey
  );
  const name = printerList[printerListIndex].name;

  //  获取模型预览图
  const modelImg = printerList[printerListIndex].project?.img || defaultModelImg

  //  获取机器目前打印的文件
  const fileName = data?.data?.filename;
  // const fileName = store.getters.GET_CUR_PRINTER?.project?.filename

  const locale = i18n;

  //  新增：添加对象（机器id/key 网络类型 机器详情）
  const obj = {
    key: modelKey,
    type: "lan",
    obj: printerList[printerListIndex],
    code: data?.code
  };

  //  增加处理逻辑，当机器返回错误时，提示弹框
  if (
    data?.code >= 10000 &&
    data?.code <= 19999 &&
    errorIdData?.[modelKey] != data?.code
  ) {
    //  获取错误码
    const errorData = JSON.parse(localStorage.getItem("error_list")) || [];
    const index = errorData?.findIndex((item) => item?.reason == data?.code);
    if (index != -1) {
      const msg = returnMessage(errorData?.[index]);
      const wiki = errorData?.[index]?.help_url;
      const dialogDiv = errorDialog({
        name,
        code: data?.code,
        fileName,
        errorTips: msg,
        url: wiki,
        isDark: store.getters.GET_IS_DARK,
        isMac: isMacOS()
      });
      //  修改错误码标题
      // const errorTitle = fileName ? locale.t('printing_error') : locale.t('operation_error')
      //  处理同样错误码报错多次的判断
      showBox(2, locale.t("error_alert"), dialogDiv, 2, `lan-${modelKey}`, 1);
      errorIdData[modelKey] = data?.code;
      store.commit("SET_ERROR_ID_DATA", errorIdData);
    }
  }

  //  增加处理逻辑，打印成功
  if (
    data?.state == "finished" &&
    data?.type == "print" &&
    data?.action == "start" &&
    !errorIdData?.[modelKey]
  ) {
    const div = successDiv({
      name,
      fileName,
      successTip: locale.t("task_completed"),
      isDark: store.getters.GET_IS_DARK,
      modelImg
    });

    showBox(2, locale.t("print_finished"), div, 2, `lan-${modelKey}`, 1);
    errorIdData[modelKey] = data?.code;
    store.commit("SET_ERROR_ID_DATA", errorIdData);
  }
}

//  获取到错误信息后需要做额外处理
function errorAfter(key, code) {
  //  判断是否当前机器
  const lanMqtt = store.getters['GET_LAN_MQTT'] || {}
  if (lanMqtt.deviceId === key && (code == 10347 || code == 10348 || code == 10349)) {
    materialsAll('light')
  }
}

//  当前错误码数组后端返回四国语言，要根据当前页面语言进行映射，其他过返回英文
function returnMessage(obj) {
  //  获取当前页面语言，进行映射
  const language = i18n.locale;
  let str = "";
  switch (language) {
    case "zh_CN":
      str = "cn";
      break;
    case "zh_TW":
      str = "cn";
      break;
    case "en":
      str = "en";
      break;
    case "ru":
      str = "ru";
      break;
    case "de":
      str = "de";
      break;
    default:
      str = "en";
      break;
  }
  return obj[`desc_${str}`];
}
